export const externalLinks = {
  defenseurDesDroits: 'https://formulaire.defenseurdesdroits.fr/',
  defenseurDesDroitsDelegue: 'https://www.defenseurdesdroits.fr/saisir/delegues',
  dgccrfFichesPratiques:
    'https://www.economie.gouv.fr/dgccrf/Publications/Vie-pratique/Fiches-pratiques-de-la-concurrence-et-de-la-consom',
  dgccrfFaq: 'https://www.economie.gouv.fr/dgccrf/foire-aux-questions-0',
  dgccrfContact: 'https://www.economie.gouv.fr/contact/contacter-la-dgccrf?dest=particulier',
  dgccrfCoordonnees: 'https://www.economie.gouv.fr/dgccrf/coordonnees-des-DDPP-et-DDETSPP',
  conciliateur: 'https://www.conciliateurs.fr',
  vosDroits: 'https://www.service-public.fr/particuliers/vosdroits/F35125',
  associationConso: 'https://www.economie.gouv.fr/dgccrf/Liste-et-coordonnees-des-associations-nationales',
  chargeBack: `https://www.economie.gouv.fr/particuliers/procedure-chargeback`,
  centreEuropeenConso: `https://www.europe-consommateurs.eu/une-question-une-reclamation.html`,
  consoAndorre: `https://www.comerc.ad/reclamacions/?id=fr`,
  econsumer: `https://www.econsumer.gov/fr`,
}
